import { BehaviorDto, IBehaviorDto } from 'src/generated_client';

export interface IExtendedBehaviorDto extends IBehaviorDto {
    isNew: boolean;
    isEdited: boolean;
}

export class ExtendedBehaviorDto extends BehaviorDto implements IExtendedBehaviorDto {
    public isNew: boolean;
    public isEdited: boolean;
    public isRemoved: boolean;

    constructor(data?: IExtendedBehaviorDto) {
        super(data);
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property)) {
                    this[property] = data[property];
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/chevrons/behaviors/ExtendedBehaviorDto.ts